/**
 * @ngdoc directive
 * @name articlesgrid
 *
 * @description
 * Complex articles grid layout
 */
module.directive('articlesgrid', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            categories: '=content'
        },
        controller: ['$scope', '$document', '$filter', function ($scope, $document, $filter) {
            // TODO: remove mock
            $scope.labelmore = 'Voir la fiche détaillée';

            /* link to anchor handler */
            $scope.goTo = function (category) {
                if (!category) {
                    return;
                }
                var dest = $filter('slugify')(category.field_titre_categorie);
                var element = angular.element(document.getElementById('article-' + dest));
                $document.scrollToElement(element, 30, 250);
            };
        }],
        template:
                '<div class="aqua-articlesgrid">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-articlesgrid--title">{{label}}</span></h2>' +

                '    <ol class="aqua-articlesgrid--menu-items grid grid-center grid-gutter">' +
                '      <li class="aqua-articlesgrid--menu-item" ng-repeat="category in categories">' +
                '        <a class="aqua-articlesgrid--menu-link" ng-click="goTo(category)">{{category.field_titre_categorie}}</a>' +
                '      </li>' +
                '    </ol>' +

                '    <div class="aqua-articlesgrid--category grid grid-v" ng-repeat="category in categories">' +

                '      <h2 ng-attr-id="article-{{category.field_titre_categorie | slugify}}" class="aqua-articlesgrid--category-title">{{category.field_titre_categorie}}</h2>' +
                '      <div class="grid grid-gutter grid-b2c-gutter">' +
                '        <article ng-repeat="article in category.field_articles_associes" content="article" labelmore="{{labelmore}}"></article>' +
                '      </div>' +

                '    </div>' +

                '  </div>' +
                '</div>'
    };
});